import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

@inject('AppState')
@observer
export default class User extends Component {
	static propTypes = {
		AppState: PropTypes.object.isRequired,
	};

	AppState = this.props.AppState;

	render() {
		const { full_name } = this.AppState.user;

		return (
			<div className="navbar-controls navbar-right Header__user">
				<span className="Header__user-name">
					{full_name}
				</span>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/Header/User.js